module.exports = __webpack_public_path__ + "media/images/img-car-5-bed413df.png";